export const colors = {
  bg1: "#662a30",
  bg1_outline: "b7525c1a",
  bg2: "#d3ae6e",
  gr_bg: "#662a30",
  gr_bg2: "#d3ae6e",
  copy_bg: "#662a30",
  blue: "#2c97ea",
  green: "#11B67A",
  green2: "#00a76a",
  red: "#ff6f6f",
  purple: "#84479c",
  yellow: "#fbab19",
  black1: "#000000",
  black2: "#444444",
  text1: "#555555",
  text2: "#666666",
  text3: "#969696",
  text4: "#aaaaaa",
  text5: "#cccccc",
  text6: "#ffffff",
  border1: "#eeeeee",
  border2: "#3e3e3e",
  border3: "#dddddd",
  footer1: "#1a1b25",
  footer2: "#16171f",
  ftext: "#8D8E92",
};

export const fonts = {
  roboto: "'Montserrat', sans-serif",
  poppins: "'Montserrat', sans-serif",
};

export const border = {
  primaryRadius: "8px",
};
